module.exports = __webpack_public_path__ + "img/slot-aristro.5f4ed59e.png";